import Mock from '../mock'
import axios from 'axios.js'
import { getApiBaseUrl, getApiKey, toMockErrorResponse, toMockResponse } from '../apiConfig'

const buildUrl = (route) => `${getApiBaseUrl()}/?apiKey=${getApiKey()}&route=${route}`

Mock.onGet('/api/brand/settings').reply(async () => {
    try {
        return toMockResponse(await axios.get(buildUrl('brand/settings/get/')))
    } catch (e) {
        console.error('brand settings get error', e)
        return toMockErrorResponse(e, 'Ошибка получения настроек брендов')
    }
})

Mock.onPost('/api/brand/settings/save').reply(async (config) => {
    try {
        const payload = config?.data ? JSON.parse(config.data) : {}
        return toMockResponse(await axios.post(buildUrl('brand/settings/save/'), payload))
    } catch (e) {
        console.error('brand settings save error', e)
        return toMockErrorResponse(e, 'Ошибка сохранения настроек брендов')
    }
})
